import * as React from "react"
import { Check } from "react-feather"
import { cn } from "@/lib/utils"

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, disabled, ...props }, ref) => {
    return (
      <label
        className={cn(
          "flex items-center gap-1.5 cursor-pointer",
          disabled && "cursor-not-allowed opacity-50",
          className
        )}
      >
        <div className="relative inline-flex items-center">
          <input
            type="checkbox"
            ref={ref}
            disabled={disabled}
            className="sr-only peer"
            {...props}
          />
          <div
            className={cn(
              "h-[18px] w-[18px] rounded-[5px] border border-[#3f4652] bg-white flex items-center justify-center",
              "peer-checked:bg-[#354267] peer-checked:border-[#354267]",
              "peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-slate-300 peer-focus-visible:ring-offset-2",
              "peer-disabled:cursor-not-allowed peer-disabled:opacity-50"
            )}
          />
          <Check
            size={14}
            className="absolute left-[2px] text-white opacity-0 peer-checked:opacity-100 pointer-events-none"
            strokeWidth={3}
          />
        </div>
        {label && (
          <span className="text-sm font-medium leading-5 text-[#3f4652] tracking-[-0.168px]">
            {label}
          </span>
        )}
      </label>
    )
  }
)
Checkbox.displayName = "Checkbox"

export { Checkbox }
